import React, { useState, useRef, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { Card, Carousel, Button, Modal } from 'react-bootstrap';
import history from '../../services/history';
import '../VerificationCards/index.scss';
import { useMutation } from '@apollo/client';
import { SUBMIT_FORM } from '../../graphql/mutatution/submitForm';
import Question from '../QuestionCards/Question/index';
import { AppContext } from '../../AppContext';

function LineVerificationCards({
  officersFormDataGrouped,
  formId,
  verificationType,
  applicationIdentifier,
  showSidebarHandler,
  showSidebar,
}) {
  const [appIdentifier] = useState(applicationIdentifier || '');
  const [carousalIndex, setCarousalIndex] = useState(0);
  const [submitForm, { called, errors }] = useMutation(SUBMIT_FORM);
  const [isLoading, setIsLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [isSubmittedOnce, setIsSubmittedOnce] = useState(false);
  const { permissionLevel, currentFlow } = useContext(AppContext);
  const [showPopUpAfterSubmit, setShowPopUpAfterSubmit] = useState(false);
  const handleClosePopUpAfterSubmit = () => setShowPopUpAfterSubmit(false);
  const handleShowAfterSubmit = () => setShowPopUpAfterSubmit(true);

  const handleSelect = (selectedIndex, e) => {
    setCarousalIndex(selectedIndex);
  };

  const submitRecommendationForm = () => {
    setIsLoading(true);
    let dataBeforeSubmittion = { ...ansState.current };

    submitForm({
      variables: {
        formInstanceId: formId,
        data: dataBeforeSubmittion,
        status: 'IN_PROCESS',
        finalRemark: '',
      },
    })
      .then(() => {
        setIsLoading(false);
        if (!errors & !called) {
          history.push('/post-verification');
        }
      })
      .catch((e) => {
        setIsLoading(false);
        setErrMsg(e.message);
        console.error(e);
      });
  };

  const ModalComponent = () => {
    return (
      <Modal
        show={showPopUpAfterSubmit}
        onHide={handleClosePopUpAfterSubmit}
        centered
      >
        <Modal.Header
          closeButton
          style={{ borderBottom: '0 none', paddingBottom: '0px' }}
        />
        <Modal.Body style={{ paddingTop: '0px' }}>
          <div className="px-2">Are you sure you want to submit?</div>
        </Modal.Body>
        <Modal.Footer
          style={{ borderTop: '0 none' }}
          className="d-flex justify-content-between"
        >
          <Button
            className="btn btn-secondary"
            onClick={() => handleClosePopUpAfterSubmit()}
            style={{ width: '30%' }}
          >
            Cancel
          </Button>
          <Button
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const nextSlide = () => {
    let duplicateIndex = carousalIndex + 1;
    if (duplicateIndex === officersFormDataGrouped.length) {
      const data = ansState.current;
      var isValid = true;

      for (
        let cardIndex = 0;
        cardIndex < officersFormDataGrouped.length;
        cardIndex++
      ) {
        for (
          let relativeQIndex = 0;
          relativeQIndex < officersFormDataGrouped[cardIndex].length;
          relativeQIndex++
        ) {
          if (
            !(
              officersFormDataGrouped[cardIndex][relativeQIndex].dbField in data
            ) ||
            !data[officersFormDataGrouped[cardIndex][relativeQIndex].dbField]
              .parent_answer ||
            data[officersFormDataGrouped[cardIndex][relativeQIndex].dbField]
              .parent_answer === '' ||
            data[officersFormDataGrouped[cardIndex][relativeQIndex].dbField]
              .parent_answer === null
          ) {
            setIsSubmittedOnce(true);
            isValid = false;
            duplicateIndex = cardIndex;
            break;
          }
        }
        if (!isValid) break;
      }

      if (isValid) {
        duplicateIndex--;
        handleShowAfterSubmit();
      }
    }
    return duplicateIndex % officersFormDataGrouped.length;
  };
  const prevSlide = () => {
    let duplicateIndex = carousalIndex - 1;
    if (duplicateIndex === -1) {
      duplicateIndex = officersFormDataGrouped.length - 1;
    }
    return duplicateIndex;
  };

  const remarksAndSubmit = (carousalIndex) => {
    return (
      <>
        <div
          className="btn-container"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <button
            className={carousalIndex === 0 ? 'd-none' : 'btn btn-light '}
            onClick={() => handleSelect(prevSlide())}
          >
            <img
              src={require('../../assets/images/arrowBackwards.svg')}
              alt="previous"
            />
            BACK
          </button>
          {!isLoading && (
            <>
              <div className="d-flex flex-column">
                <button
                  className={
                    carousalIndex === 0
                      ? 'btn btn-success btn-firstPage'
                      : 'btn btn-success '
                  }
                  onClick={() => {
                    handleSelect(nextSlide());
                  }}
                >
                  {carousalIndex === officersFormDataGrouped.length - 1
                    ? 'SUBMIT'
                    : 'NEXT'}
                  <img
                    src={require('../../assets/images/arrow.svg')}
                    alt="next"
                  />
                </button>
              </div>
            </>
          )}
          {isLoading && (
            <Button variant="secondary">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Button>
          )}
          <span>{errMsg || null}</span>
        </div>
      </>
    );
  };

  const showCarousalQuestions = () => {
    return (
      <Carousel
        activeIndex={carousalIndex}
        controls={false}
        onSelect={handleSelect}
        interval={null}
      >
        {officersFormDataGrouped.map((cardData, cardIndex) => {
          return (
            <Carousel.Item key={cardIndex}>
              <Card key={cardIndex}>
                <Card.Body key={cardIndex}>
                  {cardData.map((question, relativeIndex) => {
                    return (
                      <Question
                        question={question}
                        key={relativeIndex}
                        onChange={memoizedHandleAnswerChange}
                        validationReview={isSubmittedOnce}
                      />
                    );
                  })}
                  {remarksAndSubmit(carousalIndex)}
                </Card.Body>
              </Card>
            </Carousel.Item>
          );
        })}
      </Carousel>
    );
  };

  const ansState = useRef({});

  const handleChildAnswerChange = (dbField, value) => {
    ansState.current[dbField] = value;
  };

  const memoizedHandleAnswerChange = useCallback(handleChildAnswerChange, [
    ansState,
  ]);

  return (
    <>
      {ModalComponent()}
      <div className="main-content">
        <div className="tv-container ">
          <div className={showSidebar ? 'tv-header' : 'tv-header-expanded'}>
            <ol className="breadcrumbs">
              {/* <li
                className="active"
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  history.push('/post-verification');
                }}
              >
                <a href="#!">Post Verification</a>
              </li> */}
              <li>
                <a href="#!">{appIdentifier}</a>
              </li>
            </ol>
            {showSidebarHandler(true)}
          </div>
          <div className={showSidebar ? 'tv-content' : 'tv-content-expanded'}>
            <div style={{ float: 'right' }}>
              <ul className="stepper-dots">
                {officersFormDataGrouped.map((group, groupIndex) => (
                  <a href="#!" key={groupIndex}>
                    <li
                      className={carousalIndex === groupIndex ? 'active' : ''}
                      onClick={(e) => handleSelect(groupIndex, e)}
                    />
                  </a>
                ))}
              </ul>
            </div>
            <h6>{verificationType}</h6>
            {currentFlow === 'single-window' &&
              permissionLevel === 'CP_OFFICER' && (
                <button
                  className="primary"
                  onClick={() => {
                    history.push('/fee-verification-review');
                  }}
                >
                  NEXT
                </button>
              )}
            {showCarousalQuestions()}
          </div>
        </div>
      </div>
    </>
  );
}

LineVerificationCards.propTypes = {
  officersFormDataGrouped: PropTypes.array,
  formId: PropTypes.string,
  verificationType: PropTypes.string,
  applicationIdentifier: PropTypes.string,
  showSidebar: PropTypes.bool,
  showSidebarHandler: PropTypes.func,
};

export default LineVerificationCards;
